import React from "react";
import _ from "lodash";
import autoBind from "react-autobind";
import Select from "react-select";

class PlayerPickerDropdownFilter extends React.PureComponent {

	constructor(props) {
		super(props);
		autoBind(this);
	}

	onChange(event) {
		let value;

		if (event !== null) {
			value = event.value;
		} 

		if (this.props.onChange) {
			this.props.onChange(value);
		}
	}

	render() {

		const { item, placeholder, options, disabled } = this.props;

		let entries = [];


		_.each(options, (pickerItem, idx) => {
			entries.push({value: pickerItem.value, label: pickerItem.label});
		});

		return <Select isDisabled={disabled} placeholder={placeholder} options={entries} onChange={this.onChange} value={item.value} />;
	}
}

export default PlayerPickerDropdownFilter;